import React from 'react';
import cn from 'classnames';

import style from 'components/common/Form/Form.module.scss';

export default function Form({children, className}) {
    return <div className={cn(style.formWrapper, className)}>{children}</div>;
}
